// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".building-staff[data-v-aad2be4e] {\n  max-width: 500px;\n  margin: 0 auto;\n}\n", ""]);
// Exports
module.exports = exports;
